export type Config = {
  appBaseUrl: string;

  posthogKey: string;
  posthogHost: string;
};

function env(getter: () => string | undefined, fallback: string = ""): string {
  try {
    return getter() ?? fallback;
  } catch {
    return fallback;
  }
}

export const config: Config = {
  appBaseUrl: env(() => process.env.PDFPILOT_PUBLIC_APP_BASE_URL, "/app"),

  posthogKey: env(() => process.env.PDFPILOT_PUBLIC_POSTHOG_KEY, ""),
  posthogHost: env(() => process.env.PDFPILOT_PUBLIC_POSTHOG_HOST, "https://eu.i.posthog.com"),
};
